import { Alert, Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { API_ENDPOINT } from "../utils/constants";
import { getDbHeader, toastError } from "../utils/util";
import MuPb from "../widgets/MuPb";
import { EbadgeService } from "./EbadgeService";
const ServiceBadgePreview = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [exhibitor, setExhibitor] = useState();
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.title = "SERVICE BADGE";
  }, []);

  useEffect(() => {
    loadUser();
  }, []);
  async function loadUser() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_ENDPOINT}/onsite/get-service-badge-person-mobile?id=${encodeURIComponent(
          id
        )}`,
        getDbHeader()
      );
      if (response.status === 200) {
        setExhibitor(response.data);
      } else if (response.status === 204) {
        // Handle successful response with no content
        toast.info("No Exhibitor Found with Mobile Number.");
      }
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  }
  if (loading) {
    return <MuPb />;
  }
  if (errorMsg) {
    return (
      <Alert severity="warning">
        <Typography variant="subtitle1">{errorMsg}</Typography>
      </Alert>
    );
  }

  return (
    <Box mt={2} width={"100%"} maxWidth={420} ml={"auto"} mr={"auto"}>
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
          PLEASE SHOW THIS BADGE AT THE SECURITY TO ENTER.
        </Typography>

        <Box
          display={"flex"}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
        >
          {exhibitor && <EbadgeService user={exhibitor} isPreview={true} />}
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceBadgePreview;
